<template>
	<div class="nano-content centre_content">
		<div class="card text-center p-3 pb-0">
			<div class="card-body p-0">
				<h5 class="mt-3 mb-3">
					<img src="../../../../assets/images/silkRoadBase/member.png" class="mr-2">
						VIP专享
				</h5>
				<h4 class="f20 fn600">此内容为付费内容</h4>
				<p class="card-text f15 text-secondary mt-3 mb-3">充值成为VIP，立享新华丝路独家服务</p>
				<a href="#" class="btn btn-warning mt-3 text-white">立即开通</a>
				<p class="mt-5 mb-5">更多VIP特权功能</p>
				<div class="d-flex row justify-content-around m-0">
					<div class="card col-md-4 col-12 p-0">
						<div class="card-body">
							<img src="../../../../assets/images/silkRoadBase/56878730129766812.png">
							<h5 class="card-title mt-3 mb-3">分析师服务</h5>
							<h6 class="card-subtitle mb-2 text-muted">大量专家分析师为您服务</h6>
						</div>
					</div>
					<div class="card col-md-4 col-12 p-0">
						<div class="card-body">
							<img src="../../../../assets/images/silkRoadBase/41408370476170076.png">
							<h5 class="card-title mt-3 mb-3">咨询服务</h5>
							<h6 class="card-subtitle mb-2 text-muted">大量专家分析师为您服务</h6>
						</div>
					</div>
					<div class="card col-md-4 col-12 p-0">
						<div class="card-body">
							<img src="../../../../assets/images/silkRoadBase/507574572099684577.png">
							<h5 class="card-title mt-3 mb-3">海外活动服务</h5>
							<h6 class="card-subtitle mb-2 text-muted">大量专家分析师为您服务</h6>
						</div>
					</div>
				</div>
				<div>
					<img src="../../../../assets/images/silkRoadBase/二维码.gif">
					<p class="mt-2 text-center f14 text-secondary">扫描推送到手机</p>sd
				</div>
				<div class="pb-4 w-100 border-top-0 border-right-0 border-left-0" style="border: 1px dashed rgba(232,234,239,1);">
					<span class="float-left f12 text-black-50 pl-2 pr-2">俄罗斯</span>
					<span class="float-left f12 text-black-50 pl-2 pr-2">俄罗斯</span>
					<span class="float-left f12 text-black-50 pl-2 pr-2">俄罗斯</span>
				</div>
				<div class="w-100 viedo_article_share mt-4">
					<div class="float-left">
						<img src="../../../../assets/images/silkRoadBase/weixin.png" class="pl-2 pr-2">
						<img src="../../../../assets/images/silkRoadBase/everyone.png" class="pl-2 pr-2">
						<img src="../../../../assets/images/silkRoadBase/kongjian.png" class="pl-2 pr-2">
						<img src="../../../../assets/images/silkRoadBase/Sina_weibo.png" class="pl-2 pr-2">
						<img src="../../../../assets/images/silkRoadBase/Tencent_weibo.png" class="pl-2 pr-2">
						<img src="../../../../assets/images/silkRoadBase/add_share.png" class="pl-2 pr-2">
					</div>
					<div class="float-right">
						<button class="btn btn-outline-secondary rounded-pill f12" style="border-radius: 50px;"><i class="fa fa-thumbs-up mr-2"></i>点赞<span class="ml-2">1</span></button>
						<button class="btn btn-outline-secondary rounded-pill f12" style="border-radius: 50px;"><i class="fa fa-star mr-2"></i>收藏</button>
					</div>
				</div>

			</div>

		</div>
		<div class="d-inline-block w-100 pl-3 pr-3 mt-2" style="line-height: 70px;box-shadow:0px 0px 5px 0px rgba(0,0,0,0.05);">
			<div class="float-left">
				<img src="https://upload.imsilkroad.com/db/2018/0530/1527666768967.jpg" class="img-fluid" style="width: 45px; height: 45px;">
			</div>
			<div class="float-left ml-3">
				<p class="f14 mb-0 titleBreviary pb-2 w-75" style="line-height: 40px;">尼日利亚在普惠金融和手机银尼日利亚在普惠金融和手机银</p>
				<p class="f12 mb-0" style="line-height: 25px;">单篇购买永久获得</p>
			</div>
			<div class="float-right ml-3">
				<div>
					<button class="btn btn-primary f15" data-toggle="modal" data-target="#buyModal">单篇购买</button>
				</div>
			</div>
			<div class="float-right">
				<p class="f15">金额：20.00元</p>
			</div>
		</div>
		<!--<div class="d-flex bd-highlight p-2">
			<div class="bd-highlight"><img src="https://upload.imsilkroad.com/db/2018/0530/1527666768967.jpg" class="img-fluid" style="width: 45px; height: 45px;"></div>
			<div class="bd-highlight ml-2">
				<p class="f14 mb-0 titleBreviary pb-2">尼日利亚在普惠金融和手机银尼日利亚在普惠金融和手机银</p>
				<p class="f12 mb-0">单篇购买永久获得</p>
			</div>
			<div class="bd-highlight mr-4">
				<p class="f15 mb-0" style="line-height: 45px;">金额：20.00元</p>
			</div>
			<div class="bd-highlight"><button class="btn btn-primary f15">单篇购买</button></div>
		</div>-->
		<div class="modal fade" id="buyModal">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">订单支付</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>

					<!-- 模态框主体 -->
					<div class="modal-body">
						<div class="card border-bottom">
							<div class="card-body">
								<div class="d-flex w-100" style="">
									<div class="">
										<img src="https://upload.imsilkroad.com/db/2018/0530/1527666768967.jpg" class="img-fluid" style="width: 100px; height: 100px;">
									</div>
									<div class="flex-grow-1 ml-3">
										<p class="f15 pb-2">尼日利亚在普惠金融和手机银尼日利亚在普惠金融和手机银</p>
										<div class="">
											<p class="f14 float-left mb-0 text-black-50">单篇购买永久获得</p>
											<p class="f22 float-right mb-0 text-secondary">金额：20.00元</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="w-100" style="">
									<div class="text-center mb-2">
										<button type="button" class="btn f16 mr-5">
											<img src="../../../../assets/images/silkRoadBase/weixinPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;">微信支付
										</button>
										<button type="button" class="btn f16">
											<img src="../../../../assets/images/silkRoadBase/zhifubaoPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;">支付宝
										</button>
									</div>
									<div class="text-center">
										<p>
											<img src="../../../../assets/images/silkRoadBase/二维码.gif" class="img-fluid">
										</p>
										<p class="f16">
											<img src="../../../../assets/images/silkRoadBase/weixinPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;">
											微信扫码，支付20.00元
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'tollhint',
		data: function() {
			return {

			}
		},
		mounted() {
			this.load();
		},
	}
</script>
